import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Prohibited = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 48 48"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 5c5.12 0 9.76 2.02 13.18 5.31a2 2 0 0 1 .5.51A19 19 0 1 1 24 5zm11.93 9.9L14.9 35.93A15 15 0 0 0 36.15 15.2l-.22-.3zM24 9a15 15 0 0 0-11.93 24.1L33.1 12.07A14.93 14.93 0 0 0 24 9z"
  }));
});
Prohibited.displayName = 'Prohibited';
export var ProhibitedDimensions = {
  height: 48,
  width: 48
};